// Component
import { Grid } from '@mui/material';
import GameList from "views/components/Game/GameList";
import SearchButton from "views/components/SearchButton";

export default function MenuOtherContent({ dataMenu }) {

    return (
        <>
            <Grid container direction="row" spacing={1} justifyContent="space-between">
                <Grid item>
                    <div className="campListMenuTitle textBoldHight">
                        {
                            dataMenu.pageTitle
                        }
                    </div>
                </Grid>
                <Grid item>
                    <SearchButton></SearchButton>
                </Grid>
            </Grid>

            <div className="contentMediumMarginTop">
                <GameList></GameList>
            </div>
        </>
    );
}